import { Icon, ICONS_ENUM, Typography } from '@sanlam-glacier/app-common/components';
import styles from './hiddenWidget.module.scss';

const HiddenWidget = () => {
  return (
    <div className={styles.container}>
      <Icon
        icon={ICONS_ENUM.ACTION_2_VISIBILITY_OFF}
        className={styles.hiddenIcon}
        color={Typography.COLOR.TERTIARY}
      />
      <Typography
        variant={Typography.VARIANT.B2}
        weight={Typography.WEIGHT.MEDIUM}
        color={Typography.COLOR.TERTIARY}
      >
        Hidden
      </Typography>
    </div>
  );
};

export default HiddenWidget;
